import { apiAction } from './api';

// Admin "View as user" (server-side impersonation). These hit the real
// session-swapping endpoints — distinct from view-as.ts, which is only a
// cosmetic role-Home preview. After either call we do a FULL reload so /me
// re-resolves and the entire app re-renders with the new effective identity
// (nav, scope, data) — no stale client caches.

export async function impersonateUser(email: string): Promise<void> {
  await apiAction('/api/auth/impersonate', { email });
  window.location.assign('/');
}

export async function stopImpersonating(): Promise<void> {
  await apiAction('/api/auth/impersonate/stop', {});
  window.location.assign('/');
}
